import { cva, type VariantProps } from 'class-variance-authority';

export const barVariants = cva('rounded inline-flex', {
  variants: {
    variant: {
      primary: 'bg-primary-700',
      secondary: 'bg-secondary-700',
      tertiary: 'bg-tertiary-700',
    },
    orientation: {
      horizontal: 'px-5 py-3 justify-end items-center gap-2',
      vertical: 'px-5 py-3 flex-col justify-center items-end gap-2',
    },
  },
  defaultVariants: {
    variant: 'primary',
    orientation: 'vertical',
  },
});

export type BarVariantProps = VariantProps<typeof barVariants>;
